<script lang="ts" setup>
import { TuiTopLabelLayout } from '@clickbar/tailwindui-vue'

import { PRODUCT_CATEGORIES_KEY, type PageElementDataOfType } from '../page-builder'

const data = defineModel<PageElementDataOfType<'products'>>('data', {
  required: true,
})

const productCategories = inject(PRODUCT_CATEGORIES_KEY)!
</script>

<template>
  <TuiTopLabelLayout label="Kategorie">
    <TuiSelect
      v-model="data.categoryId"
      :options="productCategories.map((x) => ({ value: x.id, text: x.name }))"
      fixed
      placeholder="Kategorie auswählen"
    />
  </TuiTopLabelLayout>
</template>
